// THIS FILE IS AUTOMATICALLY GENERATED BY SPACETIMEDB. EDITS TO THIS FILE
// WILL NOT BE SAVED. MODIFY TABLES IN YOUR MODULE SOURCE CODE INSTEAD.

/* eslint-disable */
/* tslint:disable */
import {
  TypeBuilder as __TypeBuilder,
  t as __t,
  type AlgebraicTypeType as __AlgebraicTypeType,
  type Infer as __Infer,
} from "spacetimedb";

export const ActsForUsersOff = __t.object("ActsForUsersOff", {
  serviceId: __t.u32(),
});
export type ActsForUsersOff = __Infer<typeof ActsForUsersOff>;

// The tagged union or sum type for the algebraic type `AdminRole`.
export const AdminRole = __t.enum("AdminRole", {
  OrgAdmin: __t.unit(),
  OrgViewer: __t.unit(),
  Member: __t.unit(),
});
export type AdminRole = __Infer<typeof AdminRole>;

export const AdminUser = __t.object("AdminUser", {
  identity: __t.identity(),
  username: __t.option(__t.string()),
  get role() {
    return AdminRole;
  },
  createdAt: __t.timestamp(),
  lastConnectedAt: __t.timestamp(),
  isConnected: __t.bool(),
  get userType() {
    return UserType;
  },
});
export type AdminUser = __Infer<typeof AdminUser>;

export const AgentServiceConfig = __t.object("AgentServiceConfig", {
  id: __t.u32(),
  agentDbName: __t.string(),
  configuredAt: __t.timestamp(),
});
export type AgentServiceConfig = __Infer<typeof AgentServiceConfig>;

export const AiBudgetConfig = __t.object("AiBudgetConfig", {
  id: __t.u32(),
  inputAllowance: __t.u128(),
  outputAllowance: __t.u128(),
  anchorInputTokens: __t.u128(),
  anchorOutputTokens: __t.u128(),
  anchoredAtMs: __t.i64(),
  updatedAt: __t.timestamp(),
});
export type AiBudgetConfig = __Infer<typeof AiBudgetConfig>;

export const AiBudgetState = __t.object("AiBudgetState", {
  id: __t.u32(),
  overBudget: __t.bool(),
  inputUsed: __t.u128(),
  outputUsed: __t.u128(),
  inputAllowance: __t.u128(),
  outputAllowance: __t.u128(),
  windowStartedMs: __t.i64(),
  updatedAt: __t.timestamp(),
});
export type AiBudgetState = __Infer<typeof AiBudgetState>;

export const AssetScopeClaim = __t.object("AssetScopeClaim", {
  projectId: __t.u32(),
  claimed: __t.bool(),
  answeredAt: __t.timestamp(),
});
export type AssetScopeClaim = __Infer<typeof AssetScopeClaim>;

export const AssetScopeClaimSchedule = __t.object("AssetScopeClaimSchedule", {
  scheduledId: __t.u64(),
  scheduledAt: __t.scheduleAt(),
  projectId: __t.u32(),
  scope: __t.string(),
  projectCreatedAt: __t.timestamp(),
  attempts: __t.u8(),
});
export type AssetScopeClaimSchedule = __Infer<typeof AssetScopeClaimSchedule>;

// The tagged union or sum type for the algebraic type `BackgroundLayerKind`.
export const BackgroundLayerKind = __t.enum("BackgroundLayerKind", {
  Imagery: __t.unit(),
  Terrain: __t.unit(),
  Tiles3D: __t.unit(),
  GoogleP3Dt: __t.unit(),
});
export type BackgroundLayerKind = __Infer<typeof BackgroundLayerKind>;

export const BuiltinAgentDeploy = __t.object("BuiltinAgentDeploy", {
  serviceId: __t.u32(),
  imageId: __t.u32(),
  get resourceTier() {
    return ResourceTier;
  },
  minReplicas: __t.u8(),
  maxReplicas: __t.u8(),
  createdAt: __t.timestamp(),
});
export type BuiltinAgentDeploy = __Infer<typeof BuiltinAgentDeploy>;

export const ClearApprovalSchedule = __t.object("ClearApprovalSchedule", {
  scheduledId: __t.u64(),
  scheduledAt: __t.scheduleAt(),
  requestedBy: __t.identity(),
  targetDatabaseName: __t.option(__t.string()),
});
export type ClearApprovalSchedule = __Infer<typeof ClearApprovalSchedule>;

export const ContainerActionSchedule = __t.object("ContainerActionSchedule", {
  scheduledId: __t.u64(),
  scheduledAt: __t.scheduleAt(),
  action: __t.string(),
  deploymentId: __t.u32(),
  createdAt: __t.timestamp(),
});
export type ContainerActionSchedule = __Infer<typeof ContainerActionSchedule>;

export const ContainerStatusPollTimer = __t.object("ContainerStatusPollTimer", {
  id: __t.u64(),
  scheduledAt: __t.scheduleAt(),
  intervalMicros: __t.u64(),
});
export type ContainerStatusPollTimer = __Infer<typeof ContainerStatusPollTimer>;

export const DatabaseRetention = __t.object("DatabaseRetention", {
  databaseName: __t.string(),
  projectId: __t.u32(),
  retentionDays: __t.option(__t.u32()),
  maxRetentionDays: __t.option(__t.u32()),
  effectiveRetentionDays: __t.option(__t.u32()),
  historyFromMicros: __t.option(__t.i64()),
  retainedBytes: __t.option(__t.u64()),
  clearPending: __t.bool(),
  checkedAt: __t.option(__t.timestamp()),
  refreshAt: __t.option(__t.timestamp()),
  nextAt: __t.option(__t.timestamp()),
  lastStatus: __t.option(__t.u16()),
  lastError: __t.option(__t.string()),
  clearedBy: __t.option(__t.identity()),
  clearedAt: __t.option(__t.timestamp()),
});
export type DatabaseRetention = __Infer<typeof DatabaseRetention>;

export const DeploymentConfig = __t.object("DeploymentConfig", {
  id: __t.u32(),
  stamp: __t.string(),
  selfUrl: __t.string(),
  updatedAt: __t.timestamp(),
});
export type DeploymentConfig = __Infer<typeof DeploymentConfig>;

export const DeploymentEnv = __t.object("DeploymentEnv", {
  deploymentId: __t.u32(),
  extraEnvJson: __t.string(),
  updatedAt: __t.timestamp(),
});
export type DeploymentEnv = __Infer<typeof DeploymentEnv>;

export const DeploymentHealthTimer = __t.object("DeploymentHealthTimer", {
  id: __t.u64(),
  scheduledAt: __t.scheduleAt(),
  intervalMicros: __t.u64(),
});
export type DeploymentHealthTimer = __Infer<typeof DeploymentHealthTimer>;

// The tagged union or sum type for the algebraic type `DeploymentInstanceStatus`.
export const DeploymentInstanceStatus = __t.enum("DeploymentInstanceStatus", {
  Requested: __t.unit(),
  Deploying: __t.unit(),
  Running: __t.unit(),
  Stopped: __t.unit(),
  Failed: __t.unit(),
  Deleting: __t.unit(),
});
export type DeploymentInstanceStatus = __Infer<typeof DeploymentInstanceStatus>;

export const DeploymentLog = __t.object("DeploymentLog", {
  id: __t.u64(),
  scheduledId: __t.u64(),
  projectId: __t.u32(),
  success: __t.bool(),
  message: __t.string(),
  executedAt: __t.timestamp(),
});
export type DeploymentLog = __Infer<typeof DeploymentLog>;

// The tagged union or sum type for the algebraic type `DeploymentStatus`.
export const DeploymentStatus = __t.enum("DeploymentStatus", {
  Pending: __t.unit(),
  Deploying: __t.unit(),
  Active: __t.unit(),
  Failed: __t.unit(),
  Suspended: __t.unit(),
});
export type DeploymentStatus = __Infer<typeof DeploymentStatus>;

export const IdentityRevoke = __t.object("IdentityRevoke", {
  id: __t.u64(),
  token: __t.string(),
  tokenId: __t.u32(),
  identityHex: __t.string(),
  get serviceType() {
    return __t.option(ServiceType);
  },
  serverModule: __t.bool(),
  afterReplacement: __t.bool(),
  firstAt: __t.timestamp(),
  zeroAt: __t.option(__t.timestamp()),
  lastError: __t.string(),
});
export type IdentityRevoke = __Infer<typeof IdentityRevoke>;

export const IdentityRevokeTick = __t.object("IdentityRevokeTick", {
  scheduledId: __t.u64(),
  scheduledAt: __t.scheduleAt(),
  revokeId: __t.u64(),
});
export type IdentityRevokeTick = __Infer<typeof IdentityRevokeTick>;

export const IncludedKeyFingerprint = __t.object("IncludedKeyFingerprint", {
  id: __t.u32(),
  sha256Hex: __t.string(),
  updatedAt: __t.timestamp(),
});
export type IncludedKeyFingerprint = __Infer<typeof IncludedKeyFingerprint>;

export const Invitation = __t.object("Invitation", {
  id: __t.u32(),
  projectId: __t.u32(),
  userIdentity: __t.identity(),
  get role() {
    return ProjectUserRole;
  },
  get status() {
    return InvitationStatus;
  },
  invitedAt: __t.timestamp(),
  invitedBy: __t.identity(),
  respondedAt: __t.option(__t.timestamp()),
  expiresAt: __t.timestamp(),
  email: __t.option(__t.string()),
});
export type Invitation = __Infer<typeof Invitation>;

export const InvitationEmailSchedule = __t.object("InvitationEmailSchedule", {
  scheduledId: __t.u64(),
  scheduledAt: __t.scheduleAt(),
  orgName: __t.string(),
  email: __t.string(),
  roleSlug: __t.string(),
  requesterToken: __t.string(),
  createdAt: __t.timestamp(),
});
export type InvitationEmailSchedule = __Infer<typeof InvitationEmailSchedule>;

// The tagged union or sum type for the algebraic type `InvitationStatus`.
export const InvitationStatus = __t.enum("InvitationStatus", {
  Pending: __t.unit(),
  Accepted: __t.unit(),
  Declined: __t.unit(),
  Expired: __t.unit(),
});
export type InvitationStatus = __Infer<typeof InvitationStatus>;

// The tagged union or sum type for the algebraic type `LlmKeySource`.
export const LlmKeySource = __t.enum("LlmKeySource", {
  Platform: __t.unit(),
  Byok: __t.unit(),
});
export type LlmKeySource = __Infer<typeof LlmKeySource>;

export const LlmModelWeight = __t.object("LlmModelWeight", {
  modelId: __t.string(),
  inputWeightMilli: __t.u64(),
  cachedInputWeightMilli: __t.u64(),
  outputWeightMilli: __t.u64(),
  updatedAt: __t.timestamp(),
});
export type LlmModelWeight = __Infer<typeof LlmModelWeight>;

export const ModuleDeployment = __t.object("ModuleDeployment", {
  id: __t.u32(),
  projectId: __t.u32(),
  get moduleType() {
    return ModuleType;
  },
  databaseName: __t.string(),
  get status() {
    return DeploymentStatus;
  },
  wasmHash: __t.option(__t.string()),
  errorMessage: __t.option(__t.string()),
  createdAt: __t.timestamp(),
  updatedAt: __t.timestamp(),
  deployedBy: __t.identity(),
});
export type ModuleDeployment = __Infer<typeof ModuleDeployment>;

export const ModuleDeploymentHistory = __t.object("ModuleDeploymentHistory", {
  id: __t.u32(),
  projectId: __t.u32(),
  get moduleType() {
    return ModuleType;
  },
  databaseName: __t.string(),
  version: __t.u64(),
  wasmHash: __t.string(),
  deployedAt: __t.timestamp(),
  success: __t.bool(),
});
export type ModuleDeploymentHistory = __Infer<typeof ModuleDeploymentHistory>;

// The tagged union or sum type for the algebraic type `ModuleType`.
export const ModuleType = __t.enum("ModuleType", {
  Core: __t.unit(),
  Telemetry: __t.unit(),
  Simulator: __t.unit(),
  Launcher: __t.unit(),
  Connector: __t.unit(),
  ServerModule: __t.unit(),
});
export type ModuleType = __Infer<typeof ModuleType>;

export const ModuleUpdateResult = __t.object("ModuleUpdateResult", {
  id: __t.u32(),
  databaseName: __t.string(),
  success: __t.bool(),
  errorMessage: __t.option(__t.string()),
  completedAt: __t.timestamp(),
});
export type ModuleUpdateResult = __Infer<typeof ModuleUpdateResult>;

export const OrgBackgroundLayer = __t.object("OrgBackgroundLayer", {
  layerId: __t.string(),
  name: __t.string(),
  description: __t.string(),
  get kind() {
    return BackgroundLayerKind;
  },
  sourceUrl: __t.string(),
  attribution: __t.string(),
  licenseNote: __t.string(),
  requiresApiKey: __t.bool(),
  defaultEnabled: __t.bool(),
  maxZoom: __t.u32(),
  dailyRequestCap: __t.u32(),
  updatedAt: __t.timestamp(),
});
export type OrgBackgroundLayer = __Infer<typeof OrgBackgroundLayer>;

export const OrgBackgroundLayerKey = __t.object("OrgBackgroundLayerKey", {
  layerId: __t.string(),
  apiKey: __t.string(),
  updatedAt: __t.timestamp(),
});
export type OrgBackgroundLayerKey = __Infer<typeof OrgBackgroundLayerKey>;

export const OrgModuleDeployment = __t.object("OrgModuleDeployment", {
  id: __t.u32(),
  databaseName: __t.string(),
  moduleTypeName: __t.string(),
  deployedHash: __t.string(),
  deployedVersion: __t.u64(),
  latestHash: __t.string(),
  latestVersion: __t.u64(),
  updateAvailable: __t.bool(),
  deployedAt: __t.timestamp(),
  updatedAt: __t.timestamp(),
});
export type OrgModuleDeployment = __Infer<typeof OrgModuleDeployment>;

export const OrgModuleDeploymentHistory = __t.object("OrgModuleDeploymentHistory", {
  id: __t.u32(),
  databaseName: __t.string(),
  moduleTypeName: __t.string(),
  version: __t.u64(),
  wasmHash: __t.string(),
  deployedAt: __t.timestamp(),
  success: __t.bool(),
});
export type OrgModuleDeploymentHistory = __Infer<typeof OrgModuleDeploymentHistory>;

export const OrgOwner = __t.object("OrgOwner", {
  id: __t.u32(),
  identity: __t.identity(),
});
export type OrgOwner = __Infer<typeof OrgOwner>;

export const OrgRetention = __t.object("OrgRetention", {
  id: __t.u32(),
  get policy() {
    return RetentionPolicy;
  },
  setBy: __t.option(__t.identity()),
  setAt: __t.option(__t.timestamp()),
  platformDefaultDays: __t.option(__t.u32()),
  platformDefaultFetchedAt: __t.option(__t.timestamp()),
  passUntil: __t.option(__t.timestamp()),
  lastPassAt: __t.option(__t.timestamp()),
  routesMissingUntil: __t.option(__t.timestamp()),
});
export type OrgRetention = __Infer<typeof OrgRetention>;

export const OrgUpdatePolicyConfig = __t.object("OrgUpdatePolicyConfig", {
  id: __t.u32(),
  autoApplyOrgModules: __t.bool(),
  get orgUpdateDefault() {
    return UpdatePolicy;
  },
  autoApplyProjectModules: __t.bool(),
});
export type OrgUpdatePolicyConfig = __Infer<typeof OrgUpdatePolicyConfig>;

export const PendingModuleUpdate = __t.object("PendingModuleUpdate", {
  id: __t.u32(),
  databaseName: __t.string(),
  moduleTypeName: __t.string(),
  deployedHash: __t.string(),
  deployedVersion: __t.u64(),
  latestHash: __t.string(),
  latestVersion: __t.u64(),
  notifiedAt: __t.timestamp(),
});
export type PendingModuleUpdate = __Infer<typeof PendingModuleUpdate>;

export const PendingUser = __t.object("PendingUser", {
  identity: __t.identity(),
  username: __t.string(),
  get status() {
    return UserStatus;
  },
  requestedAt: __t.timestamp(),
  processedAt: __t.option(__t.timestamp()),
  processedBy: __t.option(__t.identity()),
});
export type PendingUser = __Infer<typeof PendingUser>;

// The tagged union or sum type for the algebraic type `PinMode`.
export const PinMode = __t.enum("PinMode", {
  Unpinned: __t.unit(),
  Tag: __t.unit(),
  Digest: __t.unit(),
});
export type PinMode = __Infer<typeof PinMode>;

export const PlatformDeploySchedule = __t.object("PlatformDeploySchedule", {
  scheduledId: __t.u64(),
  scheduledAt: __t.scheduleAt(),
  projectId: __t.u32(),
  projectName: __t.string(),
  requesterIdentity: __t.identity(),
  createdAt: __t.timestamp(),
  deployCore: __t.bool(),
  deployTelemetry: __t.bool(),
  deploySimulator: __t.bool(),
  deployConnector: __t.bool(),
  temporalCore: __t.bool(),
  temporalTelemetry: __t.bool(),
  temporalSimulator: __t.bool(),
  temporalConnector: __t.bool(),
  ownerHex: __t.option(__t.string()),
});
export type PlatformDeploySchedule = __Infer<typeof PlatformDeploySchedule>;

export const PlatformRefreshSchedule = __t.object("PlatformRefreshSchedule", {
  scheduledId: __t.u64(),
  scheduledAt: __t.scheduleAt(),
});
export type PlatformRefreshSchedule = __Infer<typeof PlatformRefreshSchedule>;

export const PostRestoreMarker = __t.object("PostRestoreMarker", {
  id: __t.u32(),
  ranAt: __t.timestamp(),
});
export type PostRestoreMarker = __Infer<typeof PostRestoreMarker>;

export const PreapprovedEmail = __t.object("PreapprovedEmail", {
  email: __t.string(),
  get role() {
    return AdminRole;
  },
  addedBy: __t.identity(),
  addedAt: __t.timestamp(),
});
export type PreapprovedEmail = __Infer<typeof PreapprovedEmail>;

export const Project = __t.object("Project", {
  id: __t.u32(),
  projectName: __t.string(),
  displayName: __t.string(),
  description: __t.string(),
  get status() {
    return ProjectStatus;
  },
  createdBy: __t.identity(),
  createdAt: __t.timestamp(),
  updatedAt: __t.timestamp(),
  autoUpdate: __t.bool(),
  isPublic: __t.bool(),
  get updatePolicy() {
    return UpdatePolicy;
  },
  assetReadScopes: __t.option(__t.array(__t.string())),
});
export type Project = __Infer<typeof Project>;

export const ProjectRetention = __t.object("ProjectRetention", {
  projectId: __t.u32(),
  get policy() {
    return RetentionPolicy;
  },
  setBy: __t.identity(),
  setAt: __t.timestamp(),
});
export type ProjectRetention = __Infer<typeof ProjectRetention>;

export const ProjectShareLink = __t.object("ProjectShareLink", {
  token: __t.string(),
  projectId: __t.u32(),
  get role() {
    return ProjectUserRole;
  },
  expiresAtMicros: __t.i64(),
  maxUses: __t.u32(),
  uses: __t.u32(),
  createdBy: __t.identity(),
  createdAt: __t.timestamp(),
});
export type ProjectShareLink = __Infer<typeof ProjectShareLink>;

// The tagged union or sum type for the algebraic type `ProjectStatus`.
export const ProjectStatus = __t.enum("ProjectStatus", {
  Active: __t.unit(),
  Suspended: __t.unit(),
  Archived: __t.unit(),
});
export type ProjectStatus = __Infer<typeof ProjectStatus>;

export const ProjectUsageLedger = __t.object("ProjectUsageLedger", {
  project: __t.string(),
  vcpuSeconds: __t.u128(),
  gibSeconds: __t.u128(),
  lastTickMs: __t.i64(),
  llmInputTokens: __t.u128(),
  llmOutputTokens: __t.u128(),
  llmInputCredits: __t.u128(),
  llmOutputCredits: __t.u128(),
  llmByokInputTokens: __t.u128(),
  llmByokCachedInputTokens: __t.u128(),
  llmByokOutputTokens: __t.u128(),
  llmByokInputCredits: __t.u128(),
  llmByokOutputCredits: __t.u128(),
});
export type ProjectUsageLedger = __Infer<typeof ProjectUsageLedger>;

export const ProjectUser = __t.object("ProjectUser", {
  id: __t.u32(),
  projectId: __t.u32(),
  userIdentity: __t.identity(),
  get role() {
    return ProjectUserRole;
  },
  assignedAt: __t.timestamp(),
  assignedBy: __t.identity(),
});
export type ProjectUser = __Infer<typeof ProjectUser>;

// The tagged union or sum type for the algebraic type `ProjectUserRole`.
export const ProjectUserRole = __t.enum("ProjectUserRole", {
  ProjectAdmin: __t.unit(),
  ProjectWriter: __t.unit(),
  ProjectReader: __t.unit(),
});
export type ProjectUserRole = __Infer<typeof ProjectUserRole>;

export const RegisteredService = __t.object("RegisteredService", {
  id: __t.u32(),
  name: __t.string(),
  get serviceType() {
    return ServiceType;
  },
  get status() {
    return ServiceStatus;
  },
  description: __t.string(),
  projectId: __t.u32(),
  tokenId: __t.option(__t.u32()),
  identityHex: __t.string(),
  targetModules: __t.string(),
  lastSeenAt: __t.option(__t.timestamp()),
  createdBy: __t.identity(),
  createdAt: __t.timestamp(),
  updatedAt: __t.timestamp(),
  healthJson: __t.option(__t.string()),
  displayName: __t.option(__t.string()),
  envKeyNames: __t.option(__t.string()),
});
export type RegisteredService = __Infer<typeof RegisteredService>;

export const ReportUsageConfig = __t.object("ReportUsageConfig", {
  id: __t.u32(),
  reportUrl: __t.string(),
  secret: __t.string(),
  billingOwnerId: __t.string(),
  sourceDb: __t.string(),
  updatedAt: __t.timestamp(),
});
export type ReportUsageConfig = __Infer<typeof ReportUsageConfig>;

// The tagged union or sum type for the algebraic type `ResourceTier`.
export const ResourceTier = __t.enum("ResourceTier", {
  Small: __t.unit(),
  Medium: __t.unit(),
  Large: __t.unit(),
});
export type ResourceTier = __Infer<typeof ResourceTier>;

export const RetentionPassTick = __t.object("RetentionPassTick", {
  scheduledId: __t.u64(),
  scheduledAt: __t.scheduleAt(),
});
export type RetentionPassTick = __Infer<typeof RetentionPassTick>;

// The tagged union or sum type for the algebraic type `RetentionPolicy`.
export const RetentionPolicy = __t.enum("RetentionPolicy", {
  Inherit: __t.unit(),
  Forever: __t.unit(),
  Days: __t.u32(),
});
export type RetentionPolicy = __Infer<typeof RetentionPolicy>;

// The tagged union or sum type for the algebraic type `RolePropagationAction`.
export const RolePropagationAction = __t.enum("RolePropagationAction", {
  SetRole: __t.unit(),
  RemoveUser: __t.unit(),
  RegisterService: __t.unit(),
  AddOrgViewer: __t.unit(),
  SetScopeGrant: __t.unit(),
  RemoveScopeGrant: __t.unit(),
  SetTenantConfig: __t.unit(),
  SetMembership: __t.unit(),
  RemoveMembership: __t.unit(),
  RemoveScopeParticipant: __t.unit(),
  SyncManagedSessionServices: __t.unit(),
  SyncRetiredServices: __t.unit(),
  EraseUserMemory: __t.unit(),
  SyncUserTokenRelayServices: __t.unit(),
  DropAssetScope: __t.unit(),
  SetProjectScope: __t.unit(),
});
export type RolePropagationAction = __Infer<typeof RolePropagationAction>;

export const RolePropagationLog = __t.object("RolePropagationLog", {
  id: __t.u64(),
  scheduledId: __t.u64(),
  get action() {
    return RolePropagationAction;
  },
  databaseName: __t.string(),
  targetIdentityHex: __t.string(),
  roleName: __t.string(),
  projectId: __t.u32(),
  success: __t.bool(),
  errorMessage: __t.option(__t.string()),
  httpStatus: __t.option(__t.u16()),
  executedAt: __t.timestamp(),
  scope: __t.option(__t.string()),
});
export type RolePropagationLog = __Infer<typeof RolePropagationLog>;

export const RolePropagationSchedule = __t.object("RolePropagationSchedule", {
  scheduledId: __t.u64(),
  scheduledAt: __t.scheduleAt(),
  get action() {
    return RolePropagationAction;
  },
  databaseName: __t.string(),
  targetIdentityHex: __t.string(),
  roleName: __t.string(),
  requesterToken: __t.string(),
  projectId: __t.u32(),
  createdAt: __t.timestamp(),
  scope: __t.option(__t.string()),
});
export type RolePropagationSchedule = __Infer<typeof RolePropagationSchedule>;

export const RoleSyncTimer = __t.object("RoleSyncTimer", {
  id: __t.u64(),
  scheduledAt: __t.scheduleAt(),
  intervalMicros: __t.u64(),
});
export type RoleSyncTimer = __Infer<typeof RoleSyncTimer>;

export const RollbackApprovalSchedule = __t.object("RollbackApprovalSchedule", {
  scheduledId: __t.u64(),
  scheduledAt: __t.scheduleAt(),
  requestedBy: __t.identity(),
  targetHistoryId: __t.u32(),
});
export type RollbackApprovalSchedule = __Infer<typeof RollbackApprovalSchedule>;

export const SelfServeConfig = __t.object("SelfServeConfig", {
  id: __t.u32(),
  enabled: __t.bool(),
  configuredBy: __t.identity(),
  configuredAt: __t.timestamp(),
});
export type SelfServeConfig = __Infer<typeof SelfServeConfig>;

export const ServerModule = __t.object("ServerModule", {
  id: __t.u32(),
  serviceId: __t.u32(),
  dbName: __t.string(),
  displayName: __t.option(__t.string()),
  get status() {
    return ServerModuleStatus;
  },
  bootstrappedAt: __t.option(__t.timestamp()),
  lastError: __t.option(__t.string()),
  createdAt: __t.timestamp(),
  receiveMembership: __t.bool(),
});
export type ServerModule = __Infer<typeof ServerModule>;

export const ServerModuleBootstrapSchedule = __t.object("ServerModuleBootstrapSchedule", {
  scheduledId: __t.u64(),
  scheduledAt: __t.scheduleAt(),
  serverModuleId: __t.u32(),
  requesterIdentity: __t.identity(),
  createdAt: __t.timestamp(),
});
export type ServerModuleBootstrapSchedule = __Infer<typeof ServerModuleBootstrapSchedule>;

// The tagged union or sum type for the algebraic type `ServerModuleStatus`.
export const ServerModuleStatus = __t.enum("ServerModuleStatus", {
  Pending: __t.unit(),
  Bootstrapping: __t.unit(),
  Active: __t.unit(),
  Failed: __t.unit(),
  Revoked: __t.unit(),
});
export type ServerModuleStatus = __Infer<typeof ServerModuleStatus>;

export const ServiceConfig = __t.object("ServiceConfig", {
  id: __t.u32(),
  orgName: __t.option(__t.string()),
  token: __t.string(),
  serviceIdentity: __t.identity(),
  createdAt: __t.timestamp(),
});
export type ServiceConfig = __Infer<typeof ServiceConfig>;

export const ServiceDeployment = __t.object("ServiceDeployment", {
  id: __t.u32(),
  imageId: __t.u32(),
  serviceId: __t.u32(),
  containerAppName: __t.string(),
  get status() {
    return DeploymentInstanceStatus;
  },
  get resourceTier() {
    return ResourceTier;
  },
  minReplicas: __t.u8(),
  maxReplicas: __t.u8(),
  errorMessage: __t.option(__t.string()),
  fqdn: __t.option(__t.string()),
  requestedBy: __t.identity(),
  createdAt: __t.timestamp(),
  updatedAt: __t.timestamp(),
  deployedAt: __t.option(__t.timestamp()),
  imagePushedAt: __t.option(__t.timestamp()),
  autoDeploy: __t.bool(),
  get pinMode() {
    return PinMode;
  },
  pinnedRef: __t.option(__t.string()),
  rescueAttempts: __t.u32(),
});
export type ServiceDeployment = __Infer<typeof ServiceDeployment>;

export const ServiceHeartbeatSweepSchedule = __t.object("ServiceHeartbeatSweepSchedule", {
  id: __t.u64(),
  scheduledAt: __t.scheduleAt(),
});
export type ServiceHeartbeatSweepSchedule = __Infer<typeof ServiceHeartbeatSweepSchedule>;

export const ServiceImage = __t.object("ServiceImage", {
  id: __t.u32(),
  name: __t.string(),
  imageUrl: __t.string(),
  get serviceType() {
    return ServiceType;
  },
  description: __t.string(),
  healthPort: __t.u16(),
  createdBy: __t.identity(),
  createdAt: __t.timestamp(),
  updatedAt: __t.timestamp(),
  latestDigest: __t.option(__t.string()),
});
export type ServiceImage = __Infer<typeof ServiceImage>;

export const ServiceLog = __t.object("ServiceLog", {
  serviceId: __t.u32(),
  linesJson: __t.string(),
  updatedAt: __t.timestamp(),
});
export type ServiceLog = __Infer<typeof ServiceLog>;

export const ServiceLogBuffer = __t.object("ServiceLogBuffer", {
  serviceId: __t.u32(),
  linesJson: __t.string(),
  updatedAt: __t.timestamp(),
});
export type ServiceLogBuffer = __Infer<typeof ServiceLogBuffer>;

export const ServiceSecret = __t.object("ServiceSecret", {
  serviceId: __t.u32(),
  secretsJson: __t.string(),
  updatedAt: __t.timestamp(),
  openaiKeyOrgSupplied: __t.bool(),
});
export type ServiceSecret = __Infer<typeof ServiceSecret>;

// The tagged union or sum type for the algebraic type `ServiceStatus`.
export const ServiceStatus = __t.enum("ServiceStatus", {
  Provisioned: __t.unit(),
  Connected: __t.unit(),
  Online: __t.unit(),
  Offline: __t.unit(),
  Revoked: __t.unit(),
});
export type ServiceStatus = __Infer<typeof ServiceStatus>;

export const ServiceTokenAuditLog = __t.object("ServiceTokenAuditLog", {
  id: __t.u64(),
  tokenId: __t.u32(),
  get event() {
    return ServiceTokenEvent;
  },
  actor: __t.identity(),
  detail: __t.string(),
  occurredAt: __t.timestamp(),
});
export type ServiceTokenAuditLog = __Infer<typeof ServiceTokenAuditLog>;

// The tagged union or sum type for the algebraic type `ServiceTokenEvent`.
export const ServiceTokenEvent = __t.enum("ServiceTokenEvent", {
  Created: __t.unit(),
  Provisioned: __t.unit(),
  Rotated: __t.unit(),
  Revoked: __t.unit(),
  Reprovisioned: __t.unit(),
  Refreshed: __t.unit(),
  ServerModuleBootstrapped: __t.unit(),
  ServerModuleBootstrapFailed: __t.unit(),
  ServerModuleRevoked: __t.unit(),
});
export type ServiceTokenEvent = __Infer<typeof ServiceTokenEvent>;

export const ServiceTokenMetadata = __t.object("ServiceTokenMetadata", {
  id: __t.u32(),
  purpose: __t.string(),
  projectId: __t.u32(),
  get consumerModuleType() {
    return ModuleType;
  },
  targetDatabase: __t.string(),
  identityHex: __t.string(),
  provisioned: __t.bool(),
  active: __t.bool(),
  revoked: __t.bool(),
  createdAt: __t.timestamp(),
  provisionedAt: __t.option(__t.timestamp()),
  createdBy: __t.identity(),
  get serviceType() {
    return __t.option(ServiceType);
  },
  registeredServiceId: __t.option(__t.u32()),
  expiresAt: __t.option(__t.timestamp()),
});
export type ServiceTokenMetadata = __Infer<typeof ServiceTokenMetadata>;

export const ServiceTokenProvisionSchedule = __t.object("ServiceTokenProvisionSchedule", {
  scheduledId: __t.u64(),
  scheduledAt: __t.scheduleAt(),
  action: __t.string(),
  projectId: __t.u32(),
  orgName: __t.string(),
  projectName: __t.string(),
  requesterToken: __t.string(),
  existingTokenId: __t.option(__t.u32()),
  requesterIdentity: __t.identity(),
  createdAt: __t.timestamp(),
  retryCount: __t.u32(),
  get serviceType() {
    return __t.option(ServiceType);
  },
  targetModuleTypes: __t.option(__t.string()),
  serviceName: __t.option(__t.string()),
  registeredServiceId: __t.option(__t.u32()),
});
export type ServiceTokenProvisionSchedule = __Infer<typeof ServiceTokenProvisionSchedule>;

export const ServiceTokenRefreshTimer = __t.object("ServiceTokenRefreshTimer", {
  scheduledId: __t.u64(),
  scheduledAt: __t.scheduleAt(),
});
export type ServiceTokenRefreshTimer = __Infer<typeof ServiceTokenRefreshTimer>;

export const ServiceTokenSecret = __t.object("ServiceTokenSecret", {
  tokenId: __t.u32(),
  token: __t.string(),
  identityHex: __t.string(),
});
export type ServiceTokenSecret = __Infer<typeof ServiceTokenSecret>;

// The tagged union or sum type for the algebraic type `ServiceType`.
export const ServiceType = __t.enum("ServiceType", {
  Agent: __t.unit(),
  Connector: __t.unit(),
  McpServer: __t.unit(),
  Simulator: __t.unit(),
  Custom: __t.unit(),
  ServerModule: __t.unit(),
  AssetService: __t.unit(),
  ExternalReader: __t.unit(),
});
export type ServiceType = __Infer<typeof ServiceType>;

export const SkippedModuleUpdate = __t.object("SkippedModuleUpdate", {
  id: __t.u32(),
  projectId: __t.u32(),
  databaseName: __t.string(),
  moduleTypeName: __t.string(),
  deployedHash: __t.string(),
  deployedVersion: __t.u64(),
  latestHash: __t.string(),
  latestVersion: __t.u64(),
  notifiedAt: __t.timestamp(),
});
export type SkippedModuleUpdate = __Infer<typeof SkippedModuleUpdate>;

export const UpdateApprovalSchedule = __t.object("UpdateApprovalSchedule", {
  scheduledId: __t.u64(),
  scheduledAt: __t.scheduleAt(),
  requestedBy: __t.identity(),
  targetDatabaseName: __t.option(__t.string()),
});
export type UpdateApprovalSchedule = __Infer<typeof UpdateApprovalSchedule>;

// The tagged union or sum type for the algebraic type `UpdatePolicy`.
export const UpdatePolicy = __t.enum("UpdatePolicy", {
  Inherit: __t.unit(),
  Auto: __t.unit(),
  Manual: __t.unit(),
});
export type UpdatePolicy = __Infer<typeof UpdatePolicy>;

export const UsageFlushSchedule = __t.object("UsageFlushSchedule", {
  id: __t.u64(),
  scheduledAt: __t.scheduleAt(),
});
export type UsageFlushSchedule = __Infer<typeof UsageFlushSchedule>;

// The tagged union or sum type for the algebraic type `UserStatus`.
export const UserStatus = __t.enum("UserStatus", {
  Pending: __t.unit(),
  Approved: __t.unit(),
  Rejected: __t.unit(),
  Suspended: __t.unit(),
});
export type UserStatus = __Infer<typeof UserStatus>;

// The tagged union or sum type for the algebraic type `UserType`.
export const UserType = __t.enum("UserType", {
  Human: __t.unit(),
  ServiceToken: __t.unit(),
  Agent: __t.unit(),
});
export type UserType = __Infer<typeof UserType>;

export const WorkosConfig = __t.object("WorkosConfig", {
  id: __t.u32(),
  workosOrgId: __t.string(),
  configuredBy: __t.identity(),
  configuredAt: __t.timestamp(),
});
export type WorkosConfig = __Infer<typeof WorkosConfig>;

